import React from 'react'
import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import SegmentedToggleButton from 'components/segmented-toggle-button'
import useCalendarStyles from 'pages/pga-coach/bookings/schedule/calendar/calendar-styles'

const YesNoSegmentControl = ({ name, ariaLabel, 'data-cy': dataCy }) => {
  const calendarClasses = useCalendarStyles()
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ value, onChange }) => (
        <ToggleButtonGroup
          exclusive
          className={calendarClasses.segmentControl}
          value={value ? 'yes' : 'no'}
          onChange={(_, nextValue) => {
            if (!nextValue) return
            onChange(nextValue === 'yes')
          }}
          aria-label={ariaLabel}
        >
          <SegmentedToggleButton
            value="yes"
            groupValue={value ? 'yes' : 'no'}
            className={calendarClasses.segmentButton}
            data-cy={dataCy}
          >
            Yes
          </SegmentedToggleButton>
          <SegmentedToggleButton
            value="no"
            groupValue={value ? 'yes' : 'no'}
            className={calendarClasses.segmentButton}
            data-cy={dataCy}
          >
            No
          </SegmentedToggleButton>
        </ToggleButtonGroup>
      )}
    />
  )
}

YesNoSegmentControl.propTypes = {
  name: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  'data-cy': PropTypes.string,
}

export default YesNoSegmentControl
